import { render, staticRenderFns } from "./devGuide.vue?vue&type=template&id=22b7e399&scoped=true&"
import script from "./devGuide.vue?vue&type=script&lang=js&"
export * from "./devGuide.vue?vue&type=script&lang=js&"
import style0 from "./devGuide.vue?vue&type=style&index=0&id=22b7e399&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b7e399",
  null
  
)

export default component.exports